/**
 * @name: supplyManagement.js
 * @description: 供应商管理路由
 * @author: 于海威
 * @create: 2020/08/07 17:15:51
 * @update: 2020/08/07 17:15:51
 */

export default [
  {
    path: '/supply/batch/consignmentlist',
    name: 'consignmentList',
    component: () => import('@/views/supply/batch/ConsignmentList'),
    meta: {
      title: '代发批次管理'
    }
  },
  {
    path: '/supply/batch/consignmentdetail',
    name: 'consignmentDetail',
    component: () => import('@/views/supply/batch/ConsignmentDetail'),
    meta: {
      parentRoutePath: 'selfsupportList',
      title: '代发批次详情'
    }
  },
  {
    path: '/supply/batch/selfsupportlist',
    name: 'selfsupportList',
    component: () => import('@/views/supply/batch/SelfsupportList'),
    meta: {
      title: '自营批次管理'
    }
  },
  {
    path: '/supply/batch/selfsupportadd',
    name: 'selfsupportAdd',
    component: () => import('@/views/supply/batch/SelfsupportAdd'),
    meta: {
      parentRoutePath: 'selfsupportList',
      title: '新增自营商品'
    }
  },
  {
    path: '/supply/freight/list',
    name: 'freightList',
    component: () => import('@/views/supply/freight/List'),
    meta: {
      title: '运费模板'
    }
  },
  {
    path: '/supply/record/list',
    name: 'recordList',
    component: () => import('@/views/supply/record/List'),
    meta: {
      title: '备案信息管理'
    }
  }
];
